import { useMemo } from 'react'

import { Forward } from 'lucide-react'

import { useSitePath } from './Header'

export default function BrowserBar() {
  const sitePath = useSitePath()

  const label = useMemo(() => {
    if (!sitePath) {
      return ''
    }

    const url = new URL(sitePath)
    const version = url.searchParams.get('__version')

    return `${url.host}${url.pathname}${version ? `?__version=${version}` : ''}`
  }, [sitePath])

  const handleOpen = () => window.open(sitePath, 'preview')

  return <div className='relative flex h-10 shrink-0 items-center justify-center bg-gray-100 border border-gray-300 rounded-t-xl px-6'>
    {label ? <button
      type='button'
      onClick={handleOpen}
      className='flex max-w-3/5 items-center gap-2 rounded-md border border-transparent bg-white px-3 py-1 font-mono text-xl text-gray-800 transition-colors duration-200 hover:border-blue-400 hover:text-blue-500'
    >
      <Forward size={18} className='shrink-0' />
      <span className='truncate'>{label}</span>
    </button> : null}
    <div className='absolute right-6 flex items-center gap-2.5'>
      <span className='size-3.5 rounded-full bg-gray-400' />
      <span className='size-3.5 rounded-full bg-gray-400' />
      <span className='size-3.5 rounded-full bg-gray-400' />
    </div>
  </div>
}
